import { PRODUCT_HOLDING_STATUS_LABELS, type ProductHoldingStatus } from '@nova/shared';

/**
 * Fill colours for the kommune choropleth. These are Nova's reserved status
 * colours (06-designsystem.md): KUNDE = success, PROSPEKT = accent, KONKURRENT =
 * danger, TIDLIGERE = warning, IKKE_RELEVANT = muted ink. The map always ships a
 * legend (labels), so identity is never colour-alone.
 */
export const STATUS_FILL: Record<ProductHoldingStatus, string> = {
  KUNDE: '#34D399',
  PROSPEKT: '#38BDF8',
  KONKURRENT_KUNDE: '#F87171',
  TIDLIGERE_KUNDE: '#FBBF24',
  IKKE_RELEVANT: '#8B98AC',
};

/** A kommune with no matching holding — recessive, so matches pop. */
export const EMPTY_FILL = 'rgba(139, 152, 172, 0.09)';
export const MAP_STROKE = 'rgba(139, 152, 172, 0.28)';
export const SELECTED_STROKE = '#38BDF8';

/** Legend rows in the dominant-status precedence order used for colouring. */
export const MAP_LEGEND: { status: ProductHoldingStatus; label: string }[] = (
  ['KUNDE', 'PROSPEKT', 'KONKURRENT_KUNDE', 'TIDLIGERE_KUNDE', 'IKKE_RELEVANT'] as const
).map((status) => ({ status, label: PRODUCT_HOLDING_STATUS_LABELS[status] }));
